var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.showDonate)?_c('div',{staticClass:"overlay",class:_vm.donateLoc},[_c('button',{staticClass:"button is-rounded is-small",on:{"click":function($event){_vm.showDonate = true}}},[_vm._v(" "+_vm._s(_vm.donateButton)+" ")])]):_c('div',[_c('DonateDialog',{on:{"done":function($event){_vm.showDonate = false}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }